<template>
  <v-row class="mx-auto" justify="center">
    <v-col cols="12" class="pa-0">
      <h2 class="mt-5 text-center light-blue--text">
        {{ $t("queue_table.subjects_in_the_queue") }} ({{
          queued_subject_list ? queued_subject_list.length : "0"
        }})
      </h2>
      <h3 class="mt-2 text-center light-blue--text text--darken-4">
        {{ $t("queue_table.description") }}
      </h3>
    </v-col>
    <v-col cols="12" lg="8" class="mb-0 pa-0">
      <v-simple-table dense class="mt-2">
        <template v-slot:default>
          <thead>
            <tr class="light-blue">
              <th class="text-center">
                {{ $t("pre_regis_add_subject.subject_id") }}
              </th>
              <th class="text-center">
                {{ $t("pre_regis_add_subject.subject_name") }}
              </th>
              <th class="text-center last-cell">
                {{ $t("pre_regis_add_subject.section") }}
              </th>
              <th v-if="change_period" class="text-center last-cell">
                {{ $t("pre_regis_add_subject.delete") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="light-blue lighten-4"
              v-for="(item, index) in queued_subject_list"
              :key="index"
            >
              <td class="text-center">{{ item.subject_id }}</td>
              <td class="text-center">
                <a class="subject-link" @click="openSubjectDialog(item.subject_id)">
                  {{ item.subject_ename }}
                </a>
              </td>
              <td class="text-center">{{ item.section }}</td>
              <td v-if="change_period" class="last-cell text-center">
                <v-btn
                  color="red"
                  dark
                  x-small
                  elevation="0"
                  @click="open_remove_queue_dialog(item)"
                  >{{ $t("queue_table.cancel_queue") }}</v-btn
                >
              </td>
            </tr>
            <tr
              v-if="!queued_subject_list || queued_subject_list.length === 0"
              class="light-blue lighten-4"
            >
              <td class="last-cell text-center" colspan="4">
                {{ $t("queue_table.no_itme") }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <subject-dialog ref="subject_dialog" :level-id="level_id" />
  </v-row>
</template>

<script>
import { db_datetime_to_dayjs } from "@/helper/dateTime";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";
export default {
  name: "QueueTable",
  components: {
    SubjectDialog,
  },
  data: () => ({}),
  props: {
    change_period: {
      type: Boolean,
      default: false,
    },
    queued_subject_list: {
      type: Array,
    },
    level_id: {
      type: [String, Number],
      default: 1,
    },
    open_remove_queue_dialog: {
      type: Function,
    },
  },
  methods: {
    db_datetime_to_dayjs,
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
  },
};
</script>

<style scoped>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
